module.exports = __webpack_public_path__ + "static/media/S4C1.5075bc82.svg";